import React from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import * as Icons from "lucide-react";
import { ArrowUpRight } from "lucide-react";
import { EQUIPMENT } from "@/constants/content";

export default function MedicalEquipmentPreview() {
  return (
    <section className="section bg-[#F8FAFC]" data-testid="equipment-section">
      <div className="container-page">
        <div className="grid lg:grid-cols-3 gap-10 lg:gap-14">
          <div className="lg:sticky lg:top-28 self-start">
            <div className="eyebrow mb-3">Medical Equipment</div>
            <h2 className="font-display font-bold text-slate-900 text-3xl md:text-4xl lg:text-5xl tracking-tight">
              Everything you need — <span className="bg-gradient-to-r from-[#0A84FF] to-[#10B981] bg-clip-text text-transparent">on rent</span>.
            </h2>
            <p className="mt-4 text-slate-600">
              From ICU beds to ventilators and oxygen — we deliver, install, and pick up. Flexible daily, weekly & monthly plans.
            </p>
            <Link
              to="/medical-equipment"
              className="mt-6 inline-flex items-center gap-2 rounded-full bg-slate-900 hover:bg-slate-800 text-white px-6 py-3 text-sm font-semibold shadow-md hover:shadow-lg transition-all"
              data-testid="equipment-explore-btn"
            >
              Explore Equipment <ArrowUpRight className="h-4 w-4" />
            </Link>
          </div>

          <div className="lg:col-span-2 grid sm:grid-cols-2 gap-3 md:gap-4">
            {EQUIPMENT.slice(0, 8).map((e, i) => {
              const Icon = Icons[e.icon] || Icons.Boxes;
              return (
                <motion.div
                  key={e.name}
                  initial={{ opacity: 0, y: 12 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true, margin: "-40px" }}
                  transition={{ duration: 0.3, delay: i * 0.04 }}
                  className="rounded-2xl border border-slate-200/70 bg-white p-4 hover:border-[#0A84FF]/30 hover:shadow-md transition-all"
                  data-testid={`equipment-${i}`}
                >
                  <div className="flex items-start gap-3">
                    <div className="h-10 w-10 rounded-xl flex items-center justify-center shrink-0" style={{ background: 'rgba(10, 132, 255, 0.1)' }}>
                      <Icon className="h-5 w-5" style={{ color: '#0A84FF' }} />
                    </div>
                    <div>
                      <div className="font-display font-semibold text-slate-900 text-sm">{e.name}</div>
                      <div className="text-xs text-slate-600 mt-0.5 leading-relaxed">{e.desc}</div>
                    </div>
                  </div>
                </motion.div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}
